import { SearchableConversationFilterInput } from 'generated-graphql/types';

export type ConversationVisibility = {
  userId: string;
  subscribedCampaignIds: string[];
};

/**
 * Mirrors the Campaigns tab: a non-admin sees campaigns they own plus the ones
 * shared with them. Admins pass `undefined` and get the whole sub-account.
 *
 * Ownership is one clause because a conversation carries the campaign owner's
 * id. See docs/adr/0003-cross-campaign-conversations-list.md.
 */
export const buildConversationVisibilityClause = (
  visibility: ConversationVisibility | undefined
): SearchableConversationFilterInput[] => {
  if (!visibility) {
    return [];
  }

  return [
    {
      or: [
        { userId: { eq: visibility.userId } },
        ...visibility.subscribedCampaignIds.map((campaignId) => ({
          campaignId: { eq: campaignId }
        }))
      ]
    }
  ];
};
